<label>{{ label }}</label>
<ng-select
  [items]="client$ | async"
  bindValue="id"
  bindLabel="business_name"
  [(ngModel)]="value"
  [typeahead]="clientInput$"
  [trackByFn]="trackClientByFn"
  (change)="onChange()"
  [multiple]="options?.multi"
  [loading]="clientLoading"
  class="client-input"
>
</ng-select>
